import { acceptHMRUpdate } from "pinia"
import { api } from "@/logic/api"
import { useAppConfigStore } from "@/store/appConfig"
import { useAppProfileConfigStore } from "@/store/appProfileConfig"
import { defineEntryListStore } from "@/store/factories/entryListStore"
import { useTranslationsStore } from "@/modules/translations/store"

export type AppSwitcherListEntry = {
  id: number
  name: string
  logo_url: string
  main_admins: number
  registered_users: number
  user_licences: number
  bought_licences: number
  auth_tokens: string
  internal_notes: string
  credits_used_last_30_days: number
  app_hosted_at: string
  slug: string
  deactivated_at: string
  online_users_last7_daily: number[]
  online_users_last7_total: number
}

export const useAppSwitcherStore = defineEntryListStore("appSwitcher", {
  state: () => {
    return {
      entries: null as null | AppSwitcherListEntry[],
      isLoading: false,
      pagination: {
        page: 1,
        totalCount: 0,
        perPage: 50,
      },
      sort: {
        by: null,
        desc: false,
      },
      filters: ["active"],
      type: "all",
      tags: [],
      searchQuery: "",
      dataLoadedCallbacks: [],
    }
  },
  getters: {
    configWatcher(): any[] {
      return [this.pagination.page, this.pagination.perPage, this.filters, this.tags, this.searchQuery, this.sort.by, this.sort.desc, this.type]
    },
    entryListRequestParams(): Record<string, any> {
      return {
        page: this.pagination.page,
        perPage: this.pagination.perPage,
        filters: this.filters,
        type: this.type,
        tags: this.tags,
        searchQuery: this.searchQuery,
        sort: this.sort,
      }
    },
  },
  actions: {
    async switchApp(appId: number) {
      const appConfigStore = useAppConfigStore()
      const appProfileConfigStore = useAppProfileConfigStore()
      const translationsStore = useTranslationsStore()

      if (appId === appConfigStore.appId) {
        throw new Error("Already on this app")
      }

      await api.get(`/apps/appswitcher/${appId}`)
      appConfigStore.appId = appId
      await Promise.all([appConfigStore.fetchSettings(), appProfileConfigStore.fetchSettings(appId)])
      translationsStore.$reset()
    },
  },
})

if (import.meta.hot) {
  // @ts-ignore
  import.meta.hot.accept(acceptHMRUpdate(useAppSwitcherStore, import.meta.hot))
}
